import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { history } from "../Router/browserHistory";
const { REACT_APP_SENTRY_DSN, REACT_APP_NODE_ENV } = process.env;

export const useSentryTracking = () => {
  useEffect(() => {
    SentryInit();
  }, []);

  const SentryInit = () =>
    Sentry.init({
      environment: REACT_APP_NODE_ENV,
      dsn: REACT_APP_SENTRY_DSN,
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
        }),
      ],
      tracesSampleRate: 1.0,
      beforeSend(event) {
        if (["development", "local"].includes(REACT_APP_NODE_ENV)) {
          if (REACT_APP_NODE_ENV === "local") {
            console.log("Dev Sentry Event -> ", event);
          }
          return null;
        }
        return event;
      },
    });
};
